import { Box, colors, Link, Stack } from "@mui/material";

import { ButtonVariant } from "Constant/button";
import { useNavigate } from "react-router-dom";

import StandartButton from "components/atoms/StandartButton";

import * as Styled from "./Content.styled";

const Content = ({
    contentTitle,
    content,
    isLoadingTrigger,
    onTrigger,
    setIsOpen,
    imageSrc,
    subscriptionModal,
}) => {
    const navigate = useNavigate();
    return (
        <Stack direction={"row"}>
            <Styled.ContentLeftSide sx={{ p: 2 }}>
                <Stack
                    justifyContent={"space-between"}
                    sx={{
                        height: "100%",
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                fontWeight: "bold",
                                fontSize: 24,
                                marginBottom: 3,
                            }}
                        >
                            {contentTitle}
                        </Box>
                        <Box
                            sx={{
                                marginBottom: 5,
                                fontSize: 14,
                            }}
                        >
                            {content}
                        </Box>
                    </Box>
                    <Box sx={{ marginTop: "auto", fontSize: 14 }}>
                        <Box
                            sx={{
                                color: colors.grey[500],
                                fontSize: 14,
                                marginBottom: 2,
                            }}
                        >
                            By clicking ‘Get Started’, you agree to our{" "}
                            <Link
                                href="https://www.signalsight.io/terms-and-conditions.html"
                                target="_blank"
                            >
                                terms and conditions
                            </Link>
                            .
                        </Box>
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            gap={2}
                        >
                            <StandartButton
                                variant={ButtonVariant.BLACK_OUTLINED}
                                onClick={() => {
                                    subscriptionModal && navigate("/");
                                    setIsOpen(false);
                                }}
                            >
                                NOT NOW
                            </StandartButton>
                            <StandartButton
                                variant={"contained"}
                                onClick={onTrigger}
                                isLoading={isLoadingTrigger}
                            >
                                GET STARTED
                            </StandartButton>
                        </Stack>
                    </Box>
                </Stack>
            </Styled.ContentLeftSide>
            <Styled.ContentRightSide>
                <img
                    style={{
                        maxHeight: "500px",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    src={imageSrc}
                    alt="subscription"
                />
            </Styled.ContentRightSide>
        </Stack>
    );
};

export default Content;
